/* import __COLOCATED_TEMPLATE__ from './nodered.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();